module.exports = __webpack_public_path__ + "static/media/img-2.d13ce9ed.png";